import { useEffect, useState } from "react";
import DynamicForm from "./DynamicForm";
import FuelEUFormFields from "./FuelEUFormFields.json";

import "./FuelEUMonitoringForm.scss";
import { AbsDropDown, Button, Input, TextArea } from "abs-ui-components";
import AsyncSelect from "react-select/async";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import axiosHttp from "../../services/interceptor";
import { emitToasterMsg } from "../../services/toasterUtility";
import DynamicTableForm from "./DynamicTableForm";
import AutocompleteDropdown from "../../common/autocompleteDropdown/AutocompleteDropdown";
import { useSelector } from "react-redux";
import { DATE_FORMAT_DD_MMM_YYYY } from "../../constants/dateFormats";

const baseURL = process.env.REACT_APP_BASE_URL;

const FuelEUMonitoringForm = (props) => {
	const user = useSelector((state) => state.userInfo.userData);
	const email = user ? user?.email : null;

	const [payload, setpayload] = useState({});
	const [inputOptions, setInputOptions] = useState([]);
	const [isTrigger, setIsTrigger] = useState(false);
	const [wcnOptions, setWcnOptions] = useState([]);
	const [errorMsgFor, setErrorMsgFor] = useState([]);

	const constructInputFields = (data, values) => {
		let initialValues = values ? { ...values } : {};

		Object.entries(data).forEach(([sectionHeader, sectionContent], index) => {
			if (sectionContent?.type) {
				if (sectionContent.type === "dynamic") {
					sectionContent.fields.forEach((field) => (field?.name ? (initialValues[field?.name] = [""]) : ""));
				} else sectionContent.fields.forEach((field) => (field?.name ? (initialValues[field?.name] = "") : ""));
			} else {
				const fetchedValues = constructInputFields(sectionContent, initialValues);
				initialValues = fetchedValues ? { ...initialValues, ...fetchedValues } : initialValues;
			}
		});
		if (email !== "") initialValues["Email"] = email;

		return initialValues;
	};

	const onDataChange = (keyValue, value, dataType) => {
		keyValue.includes("Email") && validateEmail(keyValue, value);
		if (keyValue.includes("Date")) value = value?.format(DATE_FORMAT_DD_MMM_YYYY);

		if (dataType === "number" && value !== "" && isNaN(parseInt(value))) {
			value = payload[keyValue];
		}
		setpayload((prevUnits) => {
			const updated_input_data = prevUnits;
			updated_input_data[keyValue] = value;

			return { ...prevUnits, ...updated_input_data };
		});
		setIsTrigger(true);
	};

	const fetchAssignedWcnDetails = async (inputValue) => {
		const requestedPayload = { searchKey: inputValue };
		try {
			const response = await axiosHttp.post(`${baseURL}api/Wcn/SearchWcn`, requestedPayload);
			const formattedWCNOptions = response?.data?.map((item) => ({
				label: `${item.CompanyName}`,
				value: `${item.WcnNumber}`,
				wcnMappingId: item.WcnMstId,
			}));
			setWcnOptions(formattedWCNOptions);
			return formattedWCNOptions;
		} catch (error) {
			emitToasterMsg("error", "Error", error.message);
			setWcnOptions([]);
			return [];
		}
	};

	useEffect(() => {
		fetchAssignedWcnDetails("");
		validateEmail("Email", email);
		const initialValues = constructInputFields(FuelEUFormFields);
		setpayload(initialValues);
	}, []);

	const getOptions = (types) => {
		return types
			? types.map((e) => ({
					value: e,
					label: e,
			  }))
			: [];
	};

	const setAutoDropDownOptions = (options) => {
		let ops = options?.map((e) => {
			return {
				value: e,
				label: e,
			};
		});
		if (inputOptions.length === 0) {
			setInputOptions(ops);
		}
		return true;
	};

	const filterOptions = (inputValue) => {
		return inputOptions.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
	};

	const loadOptions = (inputValue, inputOptions, callback) => {
		// return new Promise((resolve) => {
		setTimeout(() => {
			const optionsArray = Array.isArray(inputOptions) ? inputOptions : [];
			const data = inputValue ? optionsArray.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase())) : optionsArray;

			callback(data);
			// resolve({
			//   options: data
			// });
		}, 1000);
		// });
	};

	const validateEmail = (keyValue, value) => {
		var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		// Check if the email matches the pattern
		if (emailPattern.test(value)) {
			setErrorMsgFor((errorMsgFor) => errorMsgFor.filter((keyVal) => keyVal !== keyValue));
		} else {
			setErrorMsgFor((errorMsgFor) => [...errorMsgFor, keyValue]);
		}
	};

	const renderFields = (data) => {
		return Object.entries(data).map(([sectionHeader, sectionContent], index) => {
			return (
				<div key={index} className="m-3 form-outer-div">
					<h5 className="title">{sectionHeader}</h5>
					{sectionContent.type ? (
						<div key={index} className="form-inner-div">
							{sectionContent.type === "dynamic" ? (
								<DynamicForm fields={sectionContent.fields} setPayload={setpayload} payload={payload} />
							) : sectionContent.type === "dynamic-table" ? (
								<DynamicTableForm fields={sectionContent.fields} setPayload={setpayload} payload={payload} />
							) : (
								sectionContent.fields && (
									<div>
										{sectionContent.fields.map((field, fieldIndex) => (
											<div
												key={fieldIndex}
												style={{
													marginBottom: "10px",
												}}
											>
												<label
													style={{
														color: field.type === "none" && "#6c757d",
													}}
												>
													{field.label}
													{field.required && (
														<sup
															style={{
																color: "red",
															}}
														>
															*
														</sup>
													)}
												</label>
												<br />
												{field.type === "input" && (
													<Input
														className="form-input"
														type={field.name === "Email" ? "email" : field.dataType || "text"}
														autoFocus={false}
														placeholder={field.placeholder}
														required={field.required}
														// defaultValue={payload[field.name] || ''}
														value={payload[field.name] || ""}
														onChange={(e) => onDataChange(field.name, e, field.dataType)}
														onInput={(e) => {
															if (field.dataType === "number") {
																e.target.value = e.target.value.replace(/[^0-9]/g, "");
															}
														}}
													/>
												)}
												{field.type === "textarea" && (
													<TextArea
														rows={3}
														className="textarea-form-input"
														placeholder={field.placeholder}
														autoFocus={false}
														required={field.required}
														value={payload[field.name] || ""}
														onChange={(e) => onDataChange(field.name, e)}
													/>
												)}
												{field.type === "dropdown" && (
													<AbsDropDown
														options={getOptions(field.options)}
														autoFocus={false}
														value={payload[field.name] || ""}
														selected={payload[field.name] || ""}
														handleChange={(e) => onDataChange(field.name, e.value)}
														placeholder={""}
													/>
												)}
												{field.type === "auto-dropdown" &&
													(field.name !== "WCN" ? (
														<AsyncSelect
															cacheOptions
															key={index}
															defaultOptions={field.options}
															value={{
																value: payload[field.name],
																label: payload[field.name],
															}}
															loadOptions={(inputValue, callback) => {
																return loadOptions(inputValue, field.options, callback);
															}}
															onChange={(selectedOption) => onDataChange(field.name, selectedOption ? selectedOption.value : "")}
															placeholder="Select..."
															isClearable={payload[field.name] === "" ? false : true}
														/>
													) : (
														<AutocompleteDropdown
															className="auto-complete-wcn-dropdown"
															isClearable={true}
															loadOptions={fetchAssignedWcnDetails}
															placeholder="Search WCN"
															getOptionLabel={(option) => `${option.value} - ${option.label}`}
															onChange={(selectedOption) => onDataChange(field.name, selectedOption ? selectedOption.value : "")}
															defaultOptions={wcnOptions}
														/>
													))}
												{field.type === "date" && (
													<LocalizationProvider
														dateAdapter={AdapterDayjs}
														localeText={{
															fieldMonthPlaceholder: (params) => (params.contentType === "digit" ? "MM" : params.format),
														}}
													>
														<DatePicker
															format={DATE_FORMAT_DD_MMM_YYYY}
															onChange={(selectedDate) => onDataChange(field.name, selectedDate)}
															sx={{
																".MuiInputBase-root": {
																	height: "35px",
																	width: "100%",
																},
																width: "100%",
															}}
														/>
													</LocalizationProvider>
												)}
												{field.required && payload[field.name] === "" && isTrigger && (
													<p className="error mt-1">{field.requiredErrorMessage}</p>
												)}
												{payload[field.name] !== "" && errorMsgFor.indexOf(field.name) !== -1 && isTrigger && (
													<p className="error mt-1">{field.errorMessage}</p>
												)}
											</div>
										))}
									</div>
								)
							)}
							{sectionContent.table_below_label &&
								sectionContent.table_below_label.map((item) => (
									<div>
										<label>{item}</label>
									</div>
								))}
						</div>
					) : (
						renderFields(sectionContent)
					)}
				</div>
			);
		});
	};

	function transformData(data) {
		const result = {};

		// Helper function to traverse and create the nested structure
		function setNestedValue(obj, path, value) {
			// Create a nested structure based on the path
			let keys = path.split("|");
			keys.reduce((acc, key, index) => {
				if (index === keys.length - 1) {
					acc[key] = value;
				} else {
					acc[key] = acc[key] || {};
				}
				return acc[key];
			}, obj);
		}

		// Process each key in the input data
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				const value = data[key];
				setNestedValue(result, key, value);
			}
		}

		return result;
	}

	const handleFormSubmit = () => {
		const actualPayload = transformData(payload);
		setIsTrigger(true);
		if (payload["Email"] !== "" && payload["WCN"] !== "" && errorMsgFor.length === 0) {
			redirectToForm();
			setpayload({});
		}
	};
	const navigate = useNavigate();

	const redirectToForm = () => {
		navigate("/fuel-monitoring-plan");
	};

	return (
		<>
			<div className="fuel-monitoring-header-container m-3">
				<nav aria-label="breadcrumb">
					<ul className="breadcrumb">
						<li className="breadcrumb-item">
							<a onClick={redirectToForm}>List of Submissions</a>
						</li>
						<li className="breadcrumb-item active" aria-current="page">
							New Submission
						</li>
					</ul>
				</nav>
				<div className="heading-button-container">
					<h1 className="page-heading">New Submission</h1>
					<button className="action-button" onClick={redirectToForm}>
						BACK
					</button>
				</div>
			</div>
			<div className="m-3 bordered-div">
				<form onSubmit={() => handleFormSubmit()}>
					{renderFields(FuelEUFormFields)}
					<Button type="submit" className="m-3 save-button" onClick={() => handleFormSubmit()}>
						SUBMIT
					</Button>
				</form>
			</div>
		</>
	);
};
export default FuelEUMonitoringForm;
